export default __webpack_public_path__ + "static/media/seoul-si.0be448a7.png";